import api from './api';
import { MaintenanceItem } from '../types';

type ApiMaintenanceItem = MaintenanceItem & {
  vehicle_id?: number;
  estimated_amount?: number | string | null;
  internal_notes?: string | null;
  created_at?: string;
  updated_at?: string;
};

const toNum = (v: unknown): number | null => {
  if (v == null) return null;
  if (typeof v === 'number' && Number.isFinite(v)) return v;
  const s = String(v).trim();
  if (!s) return null;
  if (/,\d*$/.test(s)) return Number(s.replace(/\./g, '').replace(',', '.')) || 0;
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : null;
};

const normalizeMaintenanceItem = (raw: Record<string, unknown>): MaintenanceItem => {
  const r = raw as unknown as ApiMaintenanceItem;
  return {
    ...r,
    id: Number((raw as any).id),
    vehicle_id: Number((r as any).vehicle_id ?? (r as any).vehicleId),
    estimated_amount: toNum((r as any).estimated_amount ?? (r as any).estimatedAmount),
    internal_notes: (r as any).internal_notes ?? (r as any).internalNotes ?? null,
    created_at: (r as any).created_at,
    updated_at: (r as any).updated_at,
  };
};

const maintenanceItemService = {
  listByVehicle: async (vehicleId: number): Promise<MaintenanceItem[]> => {
    const res = await api.get(`/vehicles/${vehicleId}/maintenance-items`);
    const list = res.data || [];
    return Array.isArray(list) ? list.map((i: Record<string, unknown>) => normalizeMaintenanceItem(i)) : [];
  },

  create: async (vehicleId: number, data: Partial<MaintenanceItem>): Promise<MaintenanceItem> => {
    const res = await api.post(`/vehicles/${vehicleId}/maintenance-items`, data);
    return normalizeMaintenanceItem(res.data as Record<string, unknown>);
  },

  update: async (id: number, data: Partial<MaintenanceItem>): Promise<MaintenanceItem> => {
    const res = await api.put(`/maintenance-items/${id}`, data);
    return normalizeMaintenanceItem(res.data as Record<string, unknown>);
  },

  delete: async (id: number): Promise<number> => {
    const res = await api.delete(`/maintenance-items/${id}`);
    return res.status;
  },
};

export default maintenanceItemService;

